import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4734d180"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body-color" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "layout-container" }
const _hoisted_4 = { class: "content-area" }
const _hoisted_5 = { class: "main-content" }
const _hoisted_6 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BoosterHeader = _resolveComponent("BoosterHeader")!
  const _component_BoosterNav = _resolveComponent("BoosterNav")!
  const _component_LoadingSpinnerWithBackground = _resolveComponent("LoadingSpinnerWithBackground")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_BoosterFooter = _resolveComponent("BoosterFooter")!
  const _component_PopupBox = _resolveComponent("PopupBox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BoosterHeader),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.showNav && !_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["sidebar", { 'collapsed-Sidebar': _ctx.isCollapsed }])
              }, [
                _createVNode(_component_BoosterNav, {
                  collapsed: _ctx.isCollapsed,
                  "onUpdate:collapsed": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isCollapsed) = $event))
                }, null, 8, ["collapsed"])
              ], 2))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_ctx.loading)
                ? (_openBlock(), _createBlock(_component_LoadingSpinnerWithBackground, { key: 0 }))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("div", null, [
                _createVNode(_component_router_view)
              ], 512), [
                [_vShow, !_ctx.loading]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_BoosterFooter)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_PopupBox, {
      showPopupBox: _ctx.popupState.showPopupBox,
      "onUpdate:showPopupBox": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.popupState.showPopupBox) = $event)),
      content: _ctx.popupState.content,
      title: _ctx.popupState.title,
      okay: _ctx.popupState.okay,
      "secondary-text": _ctx.popupState.secondaryText,
      onPrimaryBtnAction: _ctx.popupState.primaryActionBtn,
      onSecondaryBtnAction: _ctx.popupState.secondaryBtnAction
    }, null, 8, ["showPopupBox", "content", "title", "okay", "secondary-text", "onPrimaryBtnAction", "onSecondaryBtnAction"])
  ], 64))
}